export default __webpack_public_path__ + "static/media/entete.6f0fda2b.jpg";